





























































import { Component, Vue } from "vue-property-decorator";
import session from "@/services/SessionService";
import messageService from "@/services/MessageService";
import router from "@/router";
import * as EmailValidator from "email-validator";

@Component
export default class PasswordRecovery extends Vue {
  // Message codes
  static RESET_SUCCESS = 1;
  static RESET_FAILURE = 2;

  // Inputs
  loading: boolean = false;
  valid: boolean = false;
  email: string = "";
  rules = {
    required: (value: string) => !!value || "El campo es requerido",
    min: (value: string) => value.length >= 6 || "Al menos 6 caracteres",
    email: (value: string) =>
      EmailValidator.validate(value) || "Correo electrónico no válido"
  };

  /**
   * Submits the email for password reset
   *
   * @param {string} email
   */
  submit(email: string) {
    if (!this.loading && this.valid) {
      this.loading = true;
      session
        .resetPassword(email)
        .then(res => {
          router.push("/");
          messageService.addMessage({
            id: PasswordRecovery.RESET_SUCCESS,
            type: "success",
            text: "Se han enviado instrucciones al correo electrónico " + email,
            overrides: true
          });
        })
        .catch(err => {
          messageService.addMessage({
            id: PasswordRecovery.RESET_FAILURE,
            type: "error",
            text: "Ha ocurrido un error. Intente nuevamente.",
            overrides: true
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
